export default {
  PAGE_SIZE: 36,
}
